import React, { useState, useEffect } from "react";
import styles from "./style.module.scss";
import { useNavigate } from "react-router-dom";
import { useDispatch,useSelector } from "react-redux";
import privacyPolicy from "../../Utilities/Redux/Services/PrivacyPolicy.Services";
function Privacy() {
  const dispatch = useDispatch()
const {getPrivacyPolicy} = useSelector((state)=>state.privacyPolicy)
//   useEffect(()=>{
// dispatch(privacyPolicy({slug:"privacy-policy"}))
//   },[])
  return (
    <div className={styles.data}>
      <h1>Privacy Policy</h1>
      {/* <p>
        <b>Effective Date: 8/4/23</b>
      </p>
      <p>
        Welcome to Fanzpick, the ultimate football opinion app! This Privacy
        Policy is designed to inform you about the data we collect, how we use
        and protect it when you use our app, and your choices regarding your
        information. By using Fanzpick, you consent to the practices described
        in this Privacy Policy.
      </p>
      <p>
        <b>1. Information We Collect:</b>
      </p>
      <p>
        Personal Information: When you sign up for Fanzpick, we may collect your
        name, email address, and other account-related information.
      </p>
      <p>
        App Usage Data: We collect information about your interactions with the
        app, including the teams you select, player ratings, and any other
        activity within Fanzpick.
      </p>
      <p>
        Third-Party API Data: Fanzpick integrates third-party API data from
        Goalserve to provide real-time match and player information. Data
        collected from Goalserve is subject to their privacy policy.
      </p>
      <p>
        <b>2. How We Use Your Information:</b>
      </p>
      <p>
        We use your personal information to create and maintain your Fanzpick
        account, improve user experience, and provide personalized content and
        features.
      </p>
      <p>
        App usage data helps us understand user preferences and optimize app
        performance.
      </p>
      <p>
        Third-party API data from Goalserve enriches the app's content and
        provides up-to-date football information.
      </p>
      <p>
        <b>3. Data Security:</b>
      </p>
      <p>
        We prioritize the security of your data and have implemented appropriate
        measures to safeguard it. However, no data transmission over the
        internet is entirely secure, and we cannot guarantee the absolute
        security of your information.
      </p>
      <p>
        <b>4. Data Sharing:</b>
      </p>
      <p>
        We do not sell, rent, or lease your personal information to third
        parties. However, we may share aggregated and anonymized data for
        analytical and marketing purposes.
      </p>
      <p>
        <b>5. Your Choices:</b>
      </p>
      <p>
        You have the right to access, correct, or delete your personal
        information. You may update your account settings or request data
        deletion by contacting us at [Your Contact Email].
      </p>
      <p>
        <b>6. Third-Party Links:</b>
      </p>
      <p>
        Fanzpick may contain links to third-party websites or services. We are
        not responsible for the privacy practices or content of these external
        sites. Please review their privacy policies separately.
      </p>
      <p>
        <b>7. Changes to this Policy:</b>
      </p>
      <p>
        We may update this Privacy Policy from time to time to reflect changes
        in our data practices. We will notify you of any material changes via
        the app or other communication channels.
      </p>
      <p>
        <b>8. Contact Us:</b>
      </p>
      <p>If you have any questions, concerns, or requests regarding this Privacy Policy or our data practices, please contact us at mailto:hello@fanzpick.com.</p>
      <p>Thank you for using Fanzpick!</p> */}
            <div dangerouslySetInnerHTML={{ __html: getPrivacyPolicy?.data?.content }} />

    </div>

  );
}

export default Privacy;
